import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import { useEffect } from "react";
import { refreshSession } from "../Features/Authentication/authSlice";
// import { store } from "../state/store";
import { store } from "../store";
import theme from "../Global/theme";
import { ThemeProvider } from "@mui/material/styles";
import MainRouter from "../Global/routing/MainRouter";
import RouteErrorBoundary from "../Global/ErrorBoundary";
import "../styles.css"
import { GlobalStyles } from "./GlobalStyles";


// Picks up a company, team or role change made since login (T8). Once per page load.
function SessionRefresh() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(refreshSession());
  }, [dispatch]);
  return null;
}

function App() {

  return (
    <Provider store={store}>
      <SessionRefresh />
      <ThemeProvider theme={theme}>
        <BrowserRouter>
        <GlobalStyles />
          <RouteErrorBoundary>
            <MainRouter />
          </RouteErrorBoundary>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
